// extracted by mini-css-extract-plugin
export var animation = "CustomerInFocus-module--animation--5e408";
export var content = "CustomerInFocus-module--content--6d3c7";
export var copy = "CustomerInFocus-module--copy--490d4";
export var image = "CustomerInFocus-module--image--3bcbe";
export var section = "CustomerInFocus-module--section--1bd7d";
export var superheading = "CustomerInFocus-module--superheading--e36d8";